export interface StatsigExperimentBucket {
  experimentName: string
  bucketName: string
  isActive: boolean | undefined
}

export interface StatsigServerProps {
  userId: string
  data: string
  key: string
  forcedBuckets: Record<string, string | string[]>
  serverSideExperiments: StatsigExperimentBucket[]
}

export enum StasigLoadingState {
  UNINITIALIZED = 'Uninitialized',
  LOADING = 'Loading',
  READY = 'Ready',
}
